import help from "../images/help.png";
import jotIt from "../images/jotit.png";
import alan from "../images/alan.png";
import game from "../images/game.png";
import tetris from "../images/tetris.png";
import crypto from "../images/crypto.png";
import ecomm from "../images/ecomm.png";


export const data = [
  {
    title: "Helping Hands",
    img: help,
    skills: "React/MongoDb/GraphQL",
    summary: "An app to help people experiencing homelessness",
    github: "https://github.com/r0yster/helping-hands",
    deployed: "https://helping-hands-deux.herokuapp.com/",
  },
  {
    title: "AlanAI News",
    img: alan,
    skills: "React/Material UI",
    summary: "A news app powered by AlanAI",
    github: "https://github.com/rsolov23/ai-react-app",
    deployed: "https://alan-ai-news-app.herokuapp.com/",
  },
  {
    title: "Tetris",
    img: tetris,
    skills: "React/styled-components",
    summary: "Tetris built with React",
    github: "https://github.com/rsolov23/tetris-react",
    deployed: "https://rsolov23.github.io/tetris-react/",
  },
  {
    title: "Cryptocurrency Tracker",
    img: crypto,
    skills: "React/axios/chart.js",
    summary: "An app to track current crypo stats",
    github: "https://github.com/rsolov23/cryptocurrency-tracker-react",
    deployed: "https://immense-lake-70800.herokuapp.com/",
  },
  {
    title: "E-commerce React App",
    img: ecomm,
    skills: "",
    summary: "",
    github: "https://github.com/rsolov23/e-commerce-react",
    deployed: "https://react-e-commerce-store.herokuapp.com/",
  },
  {
    title: "Jot It",
    img: jotIt,
    skills: "Handlebars/Express/Mysql2",
    summary: "A note taking app",
    github: "https://github.com/rsolov23/Jot-It",
    deployed: "https://jotitgood.herokuapp.com/",
  },
  {
    title: "Gaminator",
    img: game,
    skills: "JavaScript/Server-Side API",
    summary: "An app to aid in selecting a game geared towards your enjoyment",
    github: "https://github.com/rsolov23/gaminator",
    deployed: "https://lexcraw4d.github.io/Gaminator/",
  },
];
